// MED MIR — trilingual dictionary (RU default, TJ, EN)

export const LANGS = [
  { code: 'ru', label: 'RU' },
  { code: 'tj', label: 'TJ' },
  { code: 'en', label: 'EN' },
];

export const AREA_LABELS = {
  cardiology:        { ru: 'Кардиология',              tj: 'Кардиология',          en: 'Cardiology' },
  neurology:         { ru: 'Неврология',               tj: 'Неврология',           en: 'Neurology' },
  antibiotics:       { ru: 'Антибиотики',              tj: 'Антибиотикҳо',         en: 'Antibiotics' },
  gastro:            { ru: 'Гастроэнтерология',        tj: 'Гастроэнтерология',    en: 'Gastroenterology' },
  pediatrics:        { ru: 'Педиатрия',                tj: 'Педиатрия',            en: 'Pediatrics' },
  womens_health:     { ru: 'Женское здоровье',         tj: 'Саломатии занон',      en: "Women's Health" },
  oncology_support:  { ru: 'Онкоподдержка',            tj: 'Дастгирии онкологӣ',   en: 'Oncology Support' },
  respiratory:       { ru: 'Пульмонология',            tj: 'Пулмонология',         en: 'Respiratory' },
};

const T = {
  ru: {
    nav: { about: 'О компании', services: 'Услуги', products: 'Портфель', quality: 'Качество', how: 'Как мы работаем', geo: 'География', contacts: 'Контакты' },
    hero: {
      eyebrow: 'ЧДММ «МЕД МИР» · Душанбе',
      badge: 'Лицензированный оператор',
      title_a: 'Качественные',
      title_b: 'лекарства',
      title_c: 'там, где они нужнее всего.',
      lead: 'Мы соединяем проверенных производителей с дистрибьюторами, врачами и аптеками Центральной Азии — от портфеля до полки.',
      cta_partner: 'Стать партнёром',
      cta_services: 'Наши услуги',
      tag: 'Центральная Азия · С 2018',
      compliance_status: 'Batch integrity · Cold chain 2–8 °C · Online',
    },
    certs: {
      title: 'Регуляторное соответствие',
      gmp: { label: 'GMP', hint: 'Good Manufacturing Practice' },
      gdp: { label: 'GDP', hint: 'Good Distribution Practice' },
      iso: { label: 'ISO', hint: 'ISO 9001:2015' },
      pv:  { label: 'PV',  hint: 'Фармаконадзор 24/7' },
    },
    stats: {
      products: 'Продуктов в портфеле',
      areas: 'Терапевтических направлений',
      partners: 'Аптек и клиник-партнёров',
      langs: 'Языка коммуникации',
    },
    home: {
      about_eyebrow: 'О компании',
      about_title: 'Инфраструктура фармацевтики Таджикистана.',
      about_lead: 'МЕД МИР — независимый маркетинговый и дистрибьюционный оператор с прямыми контрактами с производителями Европы, СНГ и Индии. Мы работаем по стандартам GxP и GDP, отвечая за каждый шаг лекарства к пациенту.',
      about_cta: 'Подробнее о компании',
      services_eyebrow: 'Услуги',
      services_title: 'Что мы делаем',
      services_lead: 'Полный цикл вывода препарата на рынок Таджикистана: от регистрации до аптечной полки.',
      areas_eyebrow: 'Терапевтические направления',
      areas_title: '8 направлений. 60+ препаратов.',
      areas_lead: 'Портфель сформирован под реальные клинические потребности региона — от первичной помощи до сложной терапии.',
      quality_eyebrow: 'Качество',
      quality_title: 'Один стандарт — от завода до пациента.',
      quality_lead: 'Каждая партия проходит валидацию источника, транспортировки и хранения. Мы работаем только с производителями, подтверждающими GMP и стабильность серий.',
      how_eyebrow: 'Как мы работаем',
      how_title: 'Понятный процесс. Прозрачные обязательства.',
      geo_eyebrow: 'География',
      geo_title: 'Присутствие в регионе.',
      geo_lead: 'Штаб-квартира — Душанбе. Логистические партнёры и медицинские представители в основных городах Таджикистана. Расширение — Узбекистан, Кыргызстан, Афганистан.',
      cta_final_title: 'Хотите работать с нами?',
      cta_final_lead: 'Мы открыты к производителям, дистрибьюторам и медицинским учреждениям. Оставьте заявку — свяжемся в течение одного рабочего дня.',
      cta_final_btn: 'Оставить заявку',
    },
    services: [
      { t: 'Регистрация препаратов', d: 'Полное сопровождение регистрации в Минздраве Таджикистана: досье, экспертиза, обновления серий.' },
      { t: 'Маркетинг и медпродвижение', d: 'Медицинские представители, работа с KOL, конференции, обучение фармацевтов и врачей.' },
      { t: 'Дистрибьюция', d: 'Прямые контракты с крупнейшими аптечными сетями, клиниками и оптовыми игроками рынка.' },
      { t: 'Логистика с холодовой цепью', d: 'Валидированные склады с температурным мониторингом 2–8 °C и 15–25 °C, транспортировка по GDP.' },
      { t: 'Фармаконадзор', d: 'Локальная система сбора и обработки сигналов безопасности, отчёты в регуляторные органы.' },
      { t: 'Аналитика рынка', d: 'Ежемесячные отчёты по продажам, конкурентная разведка, прогнозирование спроса.' },
    ],
    steps: [
      { t: 'Аудит потребности', d: 'Оцениваем терапевтические пробелы и потенциал бренда в локальной клинической практике.' },
      { t: 'Регистрация и запуск', d: 'Ведём регистрационное досье, локальную упаковку и маркировку, вывод серий.' },
      { t: 'Промоция и обучение', d: 'Медпредставители, программы для врачей и фармацевтов, локализованные материалы.' },
      { t: 'Дистрибьюция и мониторинг', d: 'Поставки в аптеки/клиники, отслеживание спроса, фармаконадзор, ежемесячная отчётность.' },
    ],
    quality: {
      title: 'Наши стандарты качества',
      items: [
        { t: 'Только верифицированные производители', d: 'Каждый производитель проходит due diligence: GMP-сертификат, аудит завода, документы серии.' },
        { t: 'GDP-логистика', d: 'Соблюдение Good Distribution Practice: температурный мониторинг на всём пути препарата.' },
        { t: 'Фармаконадзор 24/7', d: 'Локальная точка приёма нежелательных реакций, отчёты в АНЛСМ Таджикистана.' },
        { t: 'Прослеживаемость партий', d: 'Каждая серия отслеживается от завода до аптеки — включая срок годности и условия хранения.' },
      ],
    },
    products: {
      title: 'Портфель продукции',
      lead: 'Более 60 препаратов в 8 терапевтических направлениях. Выберите категорию или воспользуйтесь поиском.',
      all: 'Все',
      search_placeholder: 'Поиск по названию или МНН…',
      empty: 'Ничего не найдено. Попробуйте другой запрос.',
      inn: 'МНН',
      form: 'Форма',
      dosage: 'Дозировка',
      manufacturer: 'Производитель',
      rx: 'Рецептурный',
      otc: 'Безрецептурный',
    },
    contacts: {
      title: 'Свяжитесь с нами',
      lead: 'Заполните форму — команда МЕД МИР свяжется с вами в течение одного рабочего дня.',
      name: 'Имя и фамилия',
      company: 'Компания',
      role: 'Должность',
      email: 'Email',
      phone: 'Телефон',
      country: 'Страна',
      message: 'Ваше сообщение',
      submit: 'Отправить заявку',
      submitting: 'Отправка…',
      success: 'Спасибо! Заявка принята. Мы свяжемся с вами в ближайшее время.',
      error: 'Не удалось отправить. Проверьте поля и повторите попытку.',
      address_title: 'Адрес',
      address_value: 'г. Душанбе, Таджикистан',
      phone_title: 'Телефон',
      email_title: 'Email',
      hours_title: 'Часы работы',
      hours_value: 'Пн–Пт · 09:00 – 18:00',
    },
    footer: {
      tagline: 'Качественные лекарства — там, где они нужнее всего.',
      nav_title: 'Разделы',
      contacts_title: 'Контакты',
      legal_title: 'Правовое',
      legal_note: 'Информация о рецептурных препаратах предназначена для медицинских специалистов.',
      copyright: '© 2026 ЧДММ «МЕД МИР». Все права защищены.',
    },
    common: { become_partner: 'Стать партнёром', explore_products: 'Смотреть продукцию' },
  },

  tj: {
    nav: { about: 'Дар бораи ширкат', services: 'Хидматҳо', products: 'Портфел', quality: 'Сифат', how: 'Тарзи кор', geo: 'Ҷуғрофия', contacts: 'Тамос' },
    hero: {
      eyebrow: 'ҶДММ «МЕД МИР» · Душанбе',
      badge: 'Оператори литсензиягӣ',
      title_a: 'Доруҳои',
      title_b: 'босифат',
      title_c: 'дар ҷое, ки бештар зарур аст.',
      lead: 'Мо истеҳсолкунандагони боэътимодро бо дистрибюторҳо, табибон ва дорухонаҳои Осиёи Марказӣ пайваст мекунем — аз портфел то раф.',
      cta_partner: 'Шарик шудан',
      cta_services: 'Хидматҳои мо',
      tag: 'Осиёи Марказӣ · Аз соли 2018',
      compliance_status: 'Batch integrity · Cold chain 2–8 °C · Online',
    },
    certs: {
      title: 'Мутобиқати танзимӣ',
      gmp: { label: 'GMP', hint: 'Good Manufacturing Practice' },
      gdp: { label: 'GDP', hint: 'Good Distribution Practice' },
      iso: { label: 'ISO', hint: 'ISO 9001:2015' },
      pv:  { label: 'PV',  hint: 'Фармаконазорати 24/7' },
    },
    stats: {
      products: 'Маҳсулот дар портфел',
      areas: 'Самти терапевтӣ',
      partners: 'Дорухона ва беморхонаҳо',
      langs: 'Забон',
    },
    home: {
      about_eyebrow: 'Дар бораи ширкат',
      about_title: 'Инфрасохтори фармасевтии Тоҷикистон.',
      about_lead: 'МЕД МИР як оператори мустақили маркетинг ва дистрибюция буда, бо истеҳсолкунандагони Аврупо, ИДМ ва Ҳиндустон шартномаҳои мустақим дорад.',
      about_cta: 'Батафсил',
      services_eyebrow: 'Хидматҳо',
      services_title: 'Кори мо',
      services_lead: 'Давраи пурраи вуруди дору ба бозори Тоҷикистон.',
      areas_eyebrow: 'Самтҳои терапевтӣ',
      areas_title: '8 самт. 60+ дору.',
      areas_lead: 'Портфел барои эҳтиёҷоти клиникии минтақа тартиб дода шудааст.',
      quality_eyebrow: 'Сифат',
      quality_title: 'Як стандарт — аз завод то бемор.',
      quality_lead: 'Ҳар як силсила аз санҷиши манбаъ, интиқол ва нигоҳдорӣ мегузарад.',
      how_eyebrow: 'Тарзи кор',
      how_title: 'Раванди фаҳмо. Уҳдадории шаффоф.',
      geo_eyebrow: 'Ҷуғрофия',
      geo_title: 'Ҳузур дар минтақа.',
      geo_lead: 'Идораи марказӣ — Душанбе. Шарикони логистикӣ дар шаҳрҳои асосии Тоҷикистон.',
      cta_final_title: 'Мехоҳед бо мо кор кунед?',
      cta_final_lead: 'Мо ба ҳамкорӣ бо истеҳсолкунандагон, дистрибюторҳо ва муассисаҳои тиббӣ омодаем.',
      cta_final_btn: 'Ирсоли дархост',
    },
    services: [
      { t: 'Бақайдгирии доруҳо', d: 'Ҳамроҳии пурраи бақайдгирӣ дар Вазорати тандурустии Тоҷикистон.' },
      { t: 'Маркетинг ва пешбарии тиббӣ', d: 'Намояндагони тиббӣ, KOL, конфронсҳо, омӯзиши духтурон.' },
      { t: 'Дистрибюция', d: 'Шартномаҳои мустақим бо шабакаҳои калонтарини дорухона.' },
      { t: 'Логистикаи занҷири сард', d: 'Анборҳои валидатсияшуда, назорати ҳарорати 2–8 °C ва 15–25 °C.' },
      { t: 'Фармаконазорат', d: 'Системаи маҳаллии ҷамъоварии сигналҳои бехатарӣ.' },
      { t: 'Таҳлили бозор', d: 'Ҳисоботи моҳона, разведкаи рақобатӣ, пешгӯии талабот.' },
    ],
    steps: [
      { t: 'Аудити эҳтиёҷот', d: 'Мо шикофҳои терапевтӣ ва потенсиали брендро арзёбӣ мекунем.' },
      { t: 'Бақайдгирӣ ва оғоз', d: 'Досяи бақайдгирӣ, бастабандӣ ва тамғагузории маҳаллӣ.' },
      { t: 'Пешбарӣ ва омӯзиш', d: 'Намояндагон, барномаҳо барои табибон ва фармасевтҳо.' },
      { t: 'Дистрибюция ва назорат', d: 'Таъминот, фармаконазорат, ҳисоботи моҳона.' },
    ],
    quality: {
      title: 'Стандартҳои сифати мо',
      items: [
        { t: 'Танҳо истеҳсолкунандагони боэътимод', d: 'Ҳар як истеҳсолкунанда due diligence мегузарад: GMP, аудити завод.' },
        { t: 'Логистикаи GDP', d: 'Риояи Good Distribution Practice дар тамоми зинҷир.' },
        { t: 'Фармаконазорати 24/7', d: 'Нуқтаи маҳаллии қабули аксуламалҳо, ҳисобот ба АМНЛТ.' },
        { t: 'Пайгирии силсилаҳо', d: 'Ҳар як силсила аз завод то дорухона пайгирӣ мешавад.' },
      ],
    },
    products: {
      title: 'Портфели маҳсулот',
      lead: 'Зиёда аз 60 дору дар 8 самт.',
      all: 'Ҳама',
      search_placeholder: 'Ҷустуҷӯ бо ном ё БНБ…',
      empty: 'Чизе ёфт нашуд.',
      inn: 'БНБ',
      form: 'Шакл',
      dosage: 'Миқдор',
      manufacturer: 'Истеҳсолкунанда',
      rx: 'Бо дастур',
      otc: 'Бе дастур',
    },
    contacts: {
      title: 'Бо мо тамос гиред',
      lead: 'Форма пур кунед — мо дар давоми як рӯзи корӣ ҷавоб медиҳем.',
      name: 'Ном ва насаб',
      company: 'Ширкат',
      role: 'Вазифа',
      email: 'Email',
      phone: 'Телефон',
      country: 'Кишвар',
      message: 'Паёми шумо',
      submit: 'Ирсоли дархост',
      submitting: 'Ирсол…',
      success: 'Ташаккур! Дархости шумо қабул шуд.',
      error: 'Ирсол нашуд. Дубора кӯшиш кунед.',
      address_title: 'Суроға',
      address_value: 'ш. Душанбе, Тоҷикистон',
      phone_title: 'Телефон',
      email_title: 'Email',
      hours_title: 'Соатҳои корӣ',
      hours_value: 'Дш–Ҷм · 09:00 – 18:00',
    },
    footer: {
      tagline: 'Доруҳои босифат — дар ҷое, ки зарур аст.',
      nav_title: 'Саҳифаҳо',
      contacts_title: 'Тамос',
      legal_title: 'Ҳуқуқӣ',
      legal_note: 'Иттилоот дар бораи доруҳои рецептӣ барои мутахассисони тиббӣ пешбинӣ шудааст.',
      copyright: '© 2026 ҶДММ «МЕД МИР». Ҳамаи ҳуқуқҳо ҳифз шудаанд.',
    },
    common: { become_partner: 'Шарик шудан', explore_products: 'Дидани маҳсулот' },
  },

  en: {
    nav: { about: 'About', services: 'Services', products: 'Portfolio', quality: 'Quality', how: 'How we work', geo: 'Geography', contacts: 'Contacts' },
    hero: {
      eyebrow: 'MED MIR LLC · Dushanbe',
      badge: 'Licensed operator',
      title_a: 'Quality',
      title_b: 'medicines',
      title_c: 'where they are needed most.',
      lead: 'We connect verified manufacturers with distributors, physicians, and pharmacies across Central Asia — from portfolio to shelf.',
      cta_partner: 'Become a partner',
      cta_services: 'Our services',
      tag: 'Central Asia · Since 2018',
      compliance_status: 'Batch integrity · Cold chain 2–8 °C · Online',
    },
    certs: {
      title: 'Regulatory compliance',
      gmp: { label: 'GMP', hint: 'Good Manufacturing Practice' },
      gdp: { label: 'GDP', hint: 'Good Distribution Practice' },
      iso: { label: 'ISO', hint: 'ISO 9001:2015' },
      pv:  { label: 'PV',  hint: '24/7 pharmacovigilance' },
    },
    stats: {
      products: 'Products in portfolio',
      areas: 'Therapeutic areas',
      partners: 'Partner pharmacies & clinics',
      langs: 'Working languages',
    },
    home: {
      about_eyebrow: 'About',
      about_title: "Tajikistan's pharmaceutical infrastructure.",
      about_lead: 'MED MIR is an independent marketing and distribution operator with direct contracts with manufacturers in Europe, CIS, and India. We operate under GxP and GDP standards.',
      about_cta: 'More about us',
      services_eyebrow: 'Services',
      services_title: 'What we do',
      services_lead: 'End-to-end market entry for pharmaceuticals in Tajikistan.',
      areas_eyebrow: 'Therapeutic areas',
      areas_title: '8 areas. 60+ products.',
      areas_lead: 'Portfolio built for the real clinical needs of the region.',
      quality_eyebrow: 'Quality',
      quality_title: 'One standard — from factory to patient.',
      quality_lead: 'Every batch is validated at source, in transit and in storage.',
      how_eyebrow: 'How we work',
      how_title: 'Clear process. Transparent commitments.',
      geo_eyebrow: 'Geography',
      geo_title: 'Regional presence.',
      geo_lead: 'Headquartered in Dushanbe. Logistics partners in major cities of Tajikistan. Expansion into Uzbekistan, Kyrgyzstan, Afghanistan.',
      cta_final_title: 'Want to work with us?',
      cta_final_lead: "We're open to manufacturers, distributors and medical institutions.",
      cta_final_btn: 'Send inquiry',
    },
    services: [
      { t: 'Drug registration', d: 'Full support for registration with the Ministry of Health of Tajikistan.' },
      { t: 'Marketing & medical promotion', d: 'Medical reps, KOL relations, conferences, physician education.' },
      { t: 'Distribution', d: 'Direct contracts with major pharmacy chains, clinics and wholesalers.' },
      { t: 'Cold-chain logistics', d: 'Validated warehouses with 2–8 °C and 15–25 °C monitoring, GDP-compliant transport.' },
      { t: 'Pharmacovigilance', d: 'Local safety signal collection and processing, regulatory reporting.' },
      { t: 'Market analytics', d: 'Monthly sales reports, competitive intelligence, demand forecasting.' },
    ],
    steps: [
      { t: 'Needs audit', d: 'We assess therapeutic gaps and brand potential in local clinical practice.' },
      { t: 'Registration & launch', d: 'Registration dossier, local packaging and labelling, batch release.' },
      { t: 'Promotion & training', d: 'Medical reps, physician and pharmacist programs, localized materials.' },
      { t: 'Distribution & monitoring', d: 'Deliveries to pharmacies/clinics, demand tracking, pharmacovigilance, monthly reporting.' },
    ],
    quality: {
      title: 'Our quality standards',
      items: [
        { t: 'Only verified manufacturers', d: 'Every manufacturer passes due diligence: GMP certification, plant audit, batch documentation.' },
        { t: 'GDP logistics', d: 'Good Distribution Practice compliance across the supply chain.' },
        { t: '24/7 pharmacovigilance', d: 'Local adverse-event intake, reporting to Tajikistan regulators.' },
        { t: 'Batch traceability', d: 'Every batch traced from factory to pharmacy, including expiry and storage.' },
      ],
    },
    products: {
      title: 'Product portfolio',
      lead: 'Over 60 products across 8 therapeutic areas. Choose a category or search.',
      all: 'All',
      search_placeholder: 'Search by name or INN…',
      empty: 'Nothing found. Try a different query.',
      inn: 'INN',
      form: 'Form',
      dosage: 'Dosage',
      manufacturer: 'Manufacturer',
      rx: 'Rx only',
      otc: 'OTC',
    },
    contacts: {
      title: 'Get in touch',
      lead: 'Fill in the form — the MED MIR team will get back to you within one business day.',
      name: 'Full name',
      company: 'Company',
      role: 'Role',
      email: 'Email',
      phone: 'Phone',
      country: 'Country',
      message: 'Your message',
      submit: 'Send inquiry',
      submitting: 'Sending…',
      success: 'Thank you! Your inquiry has been received.',
      error: 'Sending failed. Please check the fields and try again.',
      address_title: 'Address',
      address_value: 'Dushanbe, Tajikistan',
      phone_title: 'Phone',
      email_title: 'Email',
      hours_title: 'Working hours',
      hours_value: 'Mon–Fri · 09:00 – 18:00',
    },
    footer: {
      tagline: 'Quality medicines — where they are needed most.',
      nav_title: 'Site',
      contacts_title: 'Contacts',
      legal_title: 'Legal',
      legal_note: 'Prescription drug information is intended for healthcare professionals only.',
      copyright: '© 2026 MED MIR LLC. All rights reserved.',
    },
    common: { become_partner: 'Become a partner', explore_products: 'Explore products' },
  },
};

export default T;
